import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import search from '@/views/Search'
import productdetail from '@/views/ProductDetail'
import videodetail from '@/views/VideoDetail'

Vue.use(Router)

const routes = [
    {
      path: '/',
      name: 'home',
      redirect: '/home'
    },
    {
      path: '/HelloWorld',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/home',
      name: 'home',
      meta: {
        index: 1
      },
      component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
    },
    {
      path: '/video',
      name: 'video',
      meta: {
        index: 1
      },
      component: () => import(/* webpackChunkName: "home" */ '../views/Video.vue')
    },
    {
      path: '/about',
      name: 'about',
      meta: {
        index: 1
      },
      component: () => import(/* webpackChunkName: "home" */ '../views/About.vue')
    },
    {
      path: '/product',
      name: 'product',
      meta: {
        index: 1
      },
      component: () => import(/* webpackChunkName: "home" */ '../views/Product.vue')
    },
    {
      path: '/search',
      name: 'search',
      component: search
    },
    {
      path: '/productdetail',
      name: 'productdetail',
      component: productdetail
    },
    {
      path: '/videodetail',
      name: 'videodetail',
      component: videodetail
    }
    
  ]

  const router = new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
  })
  
  export default router
  



// WEBPACK FOOTER //
// ./src/router/index.js